var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4Bordny01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 254.08 184.00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "-8 192.00 262.08 192.00 262.08 -8 -8 -8 -8 192.00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "73.04 8 181.04 8 181.04 176 73.04 176 73.04 8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "8 33.65 68 33.65 68 87.65 8 87.65 8 33.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "8 33.65 17 33.65 17 87.65 8 87.65 8 33.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "186.08 33.65 246.08 33.65 246.08 87.65 186.08 87.65 186.08 33.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "237.08 33.65 246.08 33.65 246.08 87.65 237.08 87.65 237.08 33.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "8 96.35 68 96.35 68 150.35 8 150.35 8 96.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "8 96.35 17 96.35 17 150.35 8 150.35 8 96.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "186.08 96.35 246.08 96.35 246.08 150.35 186.08 150.35 186.08 96.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "237.08 96.35 246.08 96.35 246.08 150.35 237.08 150.35 237.08 96.35"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Bordny01);
export default __webpack_public_path__ + "static/media/4-bord ny-01.7c696d3f0d01b0d5035282c5263da66c.svg";
export { ForwardRef as ReactComponent };